export { default } from './svg/side-by-side-icon.svg';
